/* istanbul ignore file */

import { useLazyQuery } from '@apollo/client';
import { GET_PRODUCT_DETAILS_QUERY } from './queries';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useLazyGetProductDetails = () =>
  useLazyQuery<any>(GET_PRODUCT_DETAILS_QUERY);

export { useLazyGetProductDetails };
